module.exports = __webpack_public_path__ + "img/markets-emmert.8f451f08.jpg";